import React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    color?: string;
    size?: number;
}

export const LockIcon = (props: Props) => {
    const size = props.size ?? 24;
    const color = props.color ?? resolveColor("--theme-primary");

    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.5988 10.3502H8.99883C8.33609 10.3502 7.79883 10.8875 7.79883 11.5502V18.1502C7.79883 18.813 8.33609 19.3502 8.99883 19.3502H15.5988C16.2616 19.3502 16.7988 18.813 16.7988 18.1502V11.5502C16.7988 10.8875 16.2616 10.3502 15.5988 10.3502Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.26782 10.211V7.54041C9.25791 6.7228 9.55135 5.93052 10.0915 5.31661C10.6316 4.70271 11.38 4.31073 12.1922 4.21641C13.6598 4.06401 15.2558 4.94241 15.6038 7.34121V10.0826"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
